<template>
    <div class="spinner">
        <svg 
            class="circular" 
            viewBox="25 25 50 50">
            <circle 
                class="path" 
                cx="50" 
                cy="50"
                r="20" 
                fill="none" 
                stroke-width="2" 
                stroke-miterlimit="10" />
        </svg>
    </div>

</template>

<script>
export default {
    name: 'Spinner'
};
</script>

<style scoped>

.spinner {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);

    margin: 0 auto;
}

.spinner svg {
    width: 100px;
    height: 100px;
}

.circular {
    -webkit-animation: rotate 2s linear infinite;
    animation: rotate 2s linear infinite;
    height: 100%;
    -webkit-transform-origin: center center;
    transform-origin: center center;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}

.path {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    -webkit-animation: dash 3.5s ease-in-out infinite, color 6s ease-in-out infinite;
    animation: dash 3.5s ease-in-out infinite, color 6s ease-in-out infinite;
    stroke-linecap: round;
}

@-webkit-keyframes rotate {
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes rotate {
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
@-webkit-keyframes dash {
    0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35px;
    }
    100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124px;
    }
}
@keyframes dash {
    0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35px;
    }
    100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124px;
    }
}
@-webkit-keyframes color {
    100%,
    0% {
        stroke: #C800A0;
    }
    40% {
        stroke: #2E4887;
    }
    66% {
        stroke: #C800A0;
    }
    80%,
    90% {
        stroke: #2E4887;
    }
}
@keyframes color {
    100%,
    0% {
        stroke: #C800A0;
    }
    40% {
        stroke: #2E4887;
    }
    66% {
        stroke: #C800A0;
    }
    80%,
    90% {
        stroke: #2E4887;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue